module.exports = __webpack_public_path__ + "img/walkthrough_illust7@2x.5f954971.png";